import _ from 'lodash';
// omit old search structure
const tableQueryFromLocalStorage = _.omit(JSON.parse(window.localStorage.getItem('table-query') || '{}'),['searchBy','tags','marks','text','tagsLogicalRelation','textLogicalRelation'])

export default {
  query: {
    ...JSON.parse(JSON.stringify(tableQueryFromLocalStorage)),
    search:{},
    offset:{},
  },
  queryTemporary: {
    ...JSON.parse(JSON.stringify(tableQueryFromLocalStorage)),
    search:{},
    offset:{},
  },
  total: 0,
  currentReport: null,
  nextReportTreeLevel: 0,
  nextReportGroup: null,
  activeReports: [],
  customGroups: null,
  selectedItems: [],
  exportParams: null,
  previewLink: null,
  loading: false,
  selectedReport: null,
  drilldownFilter: null,
  drilldown: null,
  notesOpened: false,
  chartOpen: localStorage.getItem('table-chart-open') === 'true',
  chartHiddenSeries: JSON.parse(localStorage.getItem('table-chart-hidden-series') || '{}'),
  chartHiddenSeriesDashboard: JSON.parse(localStorage.getItem('table-chart-hidden-series-dashboard') || '{}'),
  activeTab: 0,
  reportBoostEnabled: JSON.parse(localStorage.getItem('report-boost-enabled')) || false,
  filters: {},
  isHideFilters: false,
  settingsTabRoute: null,
  noReportBlockVisible: false,
  progressBlockVisible: false,
  menuOverride: null,
  entityNames: {} as {[type: string]: any},
  activeTabStack: [] as number[], //TODO: login,
  customEvents: {} as {[type: string]: customEvent},
}
